import{createSelector}from'reselect';export const getSocketState=state=>state.socket;export const getSocket=createSelector(getSocketState,socket=>socket.ws);